export const auditee = {
  router: [
    {
      name: "AUDITEE",
      key: "auditee",
      path: "/admin/master/auditee",
      apiUrl: {
        data: "master/api/auditee/",
        preview: "master/api/auditee/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "AUDITEE",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
    {
      name: "no_telpon",
      label: "No Telpon",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
          {
            pattern: new RegExp(/\+?([ -]?\d+)+|\(\d+\)([ -]\d+)/),            
            message: " format telpon tidak valid",
          }
        ],
      },
      isForm: true,
      isTable: true,
    },
    {
      name: "Alamat",
      label: "Alamat",
      type: "textarea",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
